exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._34W4mjdMmLYtVg8c-TdYWm{display:block}html[dir] ._34W4mjdMmLYtVg8c-TdYWm section{padding-bottom:25px;margin-bottom:25px;border-bottom:1px solid \"[theme:neutralLighter, default:#f4f4f4]\"}._34W4mjdMmLYtVg8c-TdYWm header._2BLFDW2hmc5CuMqAeVyOSG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports
exports.locals = {
	"container": "_34W4mjdMmLYtVg8c-TdYWm",
	"title": "_2BLFDW2hmc5CuMqAeVyOSG"
};